import { useMemo } from 'react';

import { GoogleMessagesIcon, IMessageIcon, SamsungMessagesIcon } from '@change/ds-core-ui';
import { SmsIcon } from '@change/ds-icons';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { isAndroidPhone, isIPhoneOrIPad, isSamsungPhone } from 'src/app/shared/utils/userAgent';

type DeviceMessagingIcon = {
	MessagingIconComponent: typeof IMessageIcon | typeof SamsungMessagesIcon | typeof GoogleMessagesIcon | typeof SmsIcon;
	variant: 'iMessage' | 'samsungMessages' | 'googleMessages' | 'default';
};

export function useDeviceMessagingIcon(): DeviceMessagingIcon {
	const utilityContext = useUtilityContext();

	return useMemo(() => {
		if (isIPhoneOrIPad(utilityContext)) {
			return { MessagingIconComponent: IMessageIcon, variant: 'iMessage' as const };
		}
		if (isSamsungPhone(utilityContext)) {
			return { MessagingIconComponent: SamsungMessagesIcon, variant: 'samsungMessages' as const };
		}
		if (isAndroidPhone(utilityContext)) {
			return { MessagingIconComponent: GoogleMessagesIcon, variant: 'googleMessages' as const };
		}
		return { MessagingIconComponent: SmsIcon, variant: 'default' as const };
	}, [utilityContext]);
}
